import { render, staticRenderFns } from "./SubmitWallComponent.vue?vue&type=template&id=4197cdf4&scoped=true"
import script from "./SubmitWallComponent.vue?vue&type=script&lang=js"
export * from "./SubmitWallComponent.vue?vue&type=script&lang=js"
import style0 from "./SubmitWallComponent.vue?vue&type=style&index=0&id=4197cdf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4197cdf4",
  null
  
)

export default component.exports